import React, { useEffect } from 'react';
import {
  Card,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Stack,
  Box,
  useTheme,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import { useDispatch, useSelector } from 'react-redux';
import { getTransactionsRequest } from './../../store/appActions';

export default function ClinicTransactionsCard() {
  const theme = useTheme();
  const dispatch = useDispatch();

  const transactions = useSelector((state) => state.app.transactions || []);

  // console.log('transactions :', transactions)

  useEffect(() => {
    dispatch(getTransactionsRequest());
  }, [dispatch]);

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: theme.shadows[1],
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Typography
        variant="h6"
        fontWeight={theme.typography.h6.fontWeight}
        fontFamily={theme.typography.fontFamily}
        color={theme.palette.text.primary}
        mb={2}
      >
        Clinic Recent Transactions
      </Typography>

      <List>
        {transactions.map((tx, index) => (
          <ListItem
            key={index}
            divider
            sx={{
              py: 1,
            }}
          >
            <ListItemText
              primary={
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography
                    variant="body1"
                    fontWeight={500}
                    fontFamily={theme.typography.fontFamily}
                    color={theme.palette.text.primary}
                  >
                    {tx.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    fontFamily={theme.typography.fontFamily}
                    color={
                      tx.type === 'Completed'
                        ? theme.pallete.action.green
                        : theme.palette.action.purpleDark
                    }
                  >
                    {tx.amount}
                  </Typography>
                </Box>
              }
              secondary={
                <Stack direction="row" alignItems="center" spacing={1} mt={0.5}>
                  {tx.type === 'credit' ? (
                    <Chip
                      size="small"
                      label="credit"
                      sx={{
                        backgroundColor: theme.palette.action.green,
                        color: theme.palette.common.white,
                        fontWeight: 500,
                        fontFamily: theme.typography.fontFamily,
                      }}
                      icon={<CheckCircleIcon fontSize="small" sx={{ color: theme.palette.gery.black }} />}
                    />
                  ) : (
                    <Chip
                      size="small"
                      label="debit"
                      sx={{
                        backgroundColor: theme.palette.action.purpleDark,
                        color: theme.palette.common.white,
                        fontWeight: 500,
                        fontFamily: theme.typography.fontFamily,
                      }}
                      icon={<HourglassBottomIcon fontSize="small" sx={{ color: theme.palette.gery.black }} />}
                    />
                  )}
                </Stack>
              }
            />
          </ListItem>
        ))}
      </List>
    </Card>
  );
}
